import { Check, Timer, Wrench, PackageOpen } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { scrollToId } from "@/lib/api";

const INCLUDED = [
  "Specialist leak detection technician",
  "Acoustic, thermal, moisture & pressure gear",
  "$200 specialty tool fee already included",
  "All prices include GST",
];

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="py-24 sm:py-32 bg-brand noise-overlay relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="font-bold text-xs tracking-[0.3em] text-tlime uppercase mb-4">Chapter 03 — The price list</p>
        <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.9] max-w-4xl">
          THE PRICE. <span className="text-tlime">IN BIG PRINT.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-white/85 text-base sm:text-lg">
          Check the other leak sites. We'll wait. Nobody else publishes theirs —
          because nobody else is this sure it's fair.
        </p>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-5 gap-5 items-stretch">
        <Reveal className="lg:col-span-3">
          <div data-testid="pricing-main-card" className="h-full rounded-3xl bg-navy noise-overlay relative p-10 sm:p-14 overflow-hidden">
            <span className="absolute top-8 right-8 rounded-full bg-tlime text-navy text-[10px] font-extrabold tracking-widest px-4 py-2">
              INC. GST
            </span>
            <p className="font-bold text-xs tracking-[0.3em] text-brand uppercase">First half-hour of detection</p>
            <p className="mt-4 font-bebas text-[26vw] sm:text-[10rem] leading-[0.85] text-white">
              $360<span className="text-brand">.</span>
            </p>
            <p className="text-white/60 max-w-md">
              Inclusive of the $200 specialty tool fee. That half-hour buys you a dedicated leak
              detective and the full spy kit.
            </p>
            <ul className="mt-8 space-y-3">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-white/80">
                  <span className="w-6 h-6 rounded-full bg-brand/20 flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-brand" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <div className="lg:col-span-2 grid gap-5">
          <Reveal delay={0.1}>
            <div data-testid="pricing-increment-card" className="rounded-3xl border-2 border-brand/30 bg-brand-light/40 p-8 h-full">
              <Timer className="w-8 h-8 text-brand mb-4" />
              <p className="font-bebas text-5xl text-navy leading-none">$45 <span className="text-2xl text-navy/50">/ 15 MIN</span></p>
              <p className="mt-3 text-sm text-navy/60">
                Leak playing hard to get? $45 per 15 after the first half-hour. Most crack sooner.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <div data-testid="pricing-repair-card" className="rounded-3xl border border-border bg-white p-8 shadow-sm h-full">
              <Wrench className="w-8 h-8 text-brand mb-4" />
              <p className="font-bebas text-3xl text-navy leading-none">FOUND IT? WE QUOTE THE FIX.</p>
              <p className="mt-3 text-sm text-navy/60">
                Once located, you get an upfront repair quote before any work starts. Any materials are quoted separately — no surprises, ever.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="rounded-3xl bg-tpink p-8 h-full flex flex-col justify-between gap-4">
              <div className="flex items-center gap-3">
                <PackageOpen className="w-8 h-8 text-white" />
                <p className="font-bebas text-2xl text-white tracking-wide">NO HIDDEN FEES. EVER.</p>
              </div>
              <button
                data-testid="pricing-book-button"
                onClick={() => scrollToId("book")}
                className="rounded-full bg-white text-navy font-bebas text-xl tracking-wide px-8 py-3 text-center hover:-translate-y-0.5 hover:shadow-xl transition-[transform,box-shadow] duration-300"
              >
                LOCK IN MY SLOT
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
